export default "__VITE_ASSET__DZUMwu7t__"